export const DOC_UPLOAD_STATUS_IDS = {
  PENDING: 1,
  VERIFYING: 2,
  UNDER_REVIEW: 3,
  FAILED: 4,
  VERIFIED: 5,
  PROCESSING: 6,
  UPLOADING: 7,
};
